import { CantonalBallotsSummary } from '@/components/CantonalBallotsSummary'
import { Container } from '@/components/Container'
import { ContentHead } from '@/components/ContentHead'
import { PageHeader } from '@/components/page-header'
import { TobiIntegration } from '@/components/tobi-integration'
import { publicationPreferredCantonIds } from '@/domain'
import { useFirestoreSnapshot, usePopularVoteDocument } from '@/lib/connectToFirestore'
import { useEnv } from '@/lib/env'
import { CenteredLoader } from '@/materials'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router-dom'
import { css } from 'styled-components/macro'
import { Impressum } from '../../../../compositions/impressum/impressum'
import * as firestore from 'firebase/firestore'

export interface Params {
  popularVoteId: string
}

export default (function Page() {
  const { db } = useEnv()

  const params = useParams<Params>()

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [params.popularVoteId])

  const { popularVoteId } = params

  const popularVoteDocument = usePopularVoteDocument(params)
  const cantons = useFirestoreSnapshot(firestore.collection(db, 'popularVotes', popularVoteId, 'cantons'))

  if (!popularVoteDocument || !cantons) {
    return (
      <>
        <PageHeader popularVoteId={popularVoteId} activeTab="cantonal" />
        <CenteredLoader />
      </>
    )
  }

  return (
    <>
      <PageHeader popularVoteId={popularVoteId} activeTab="cantonal" />

      <div css={styles.content as any}>
        <Container maxWidth={8}>
          <ContentHead
            header={<FormattedMessage id="8PRFV44" defaultMessage="Kantonale Vorlagen" />}
            text={<FormattedMessage id="mhUkiN6" defaultMessage="Abstimmungen in den Kantonen" />}
          />
        </Container>

        <Container maxWidth={4}>
          <TobiIntegration popularVoteId={popularVoteId} />
        </Container>

        {publicationPreferredCantonIds()
          .filter((cantonId) => !!cantons.docs.find((doc) => doc.id === cantonId))
          .map((cantonId) => (
            <Container maxWidth={8}>
              <CantonalBallotsSummary popularVoteId={popularVoteId} cantonId={cantonId} />
            </Container>
          ))}
      </div>

      <Impressum />
    </>
  )
})

const styles = {
  content: css`
    display: grid;
    grid-template-columns: 1fr;
    justify-items: stretch;
    row-gap: 60px;

    padding: 20px 0 60px;

    @media only screen and (min-width: 1072px) {
      padding: 60px 0 80px;
      row-gap: 80px;
    }
  `,
}
